
  import * as ipxRuntime$wCxz3Cb9GkiOIfwRbRzq6HVWWAjMS6xF6EmtgMBQlsI from '/home/forge/career.proxify.io/releases/20261023135732/node_modules/.pnpm/@nuxt+image@1.11.0_ioredis@5.4.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "default": {
      "modifiers": {
        "format": "webp",
        "quality": 100
      }
    }
  },
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$wCxz3Cb9GkiOIfwRbRzq6HVWWAjMS6xF6EmtgMBQlsI, defaults: {} }
    }
  }
